// src/onboarding/spotlight.js
// Phase 37 — extracted from src/App.jsx (Plan 37-03).
//
// Scope: pure colour resolver for the OnboardingPlant spotlight flower.
// Public exports: onbResolveSpotlightColors.
// Module state: none.

import { STATIC_PLANT_COLOURS } from '../data/colours.js';
import { ONB_SPOTLIGHT_FALLBACKS } from './constants.js';

// Resolve a [primary, shadow] hex pair for the OnboardingPlant spotlight flower.
// Algorithm (pre-committed — no executor-time branching):
//   1. Normalise input to lowercase + trim. Empty → neutral green fallback.
//   2. STATIC_PLANT_COLOURS exact-key lookup. If match, iterate month keys 1..12
//      and use the first non-empty hex as `primary`.
//   3. ONB_SPOTLIGHT_FALLBACKS keyword scan (first match wins on the keys as
//      ordered above). Returns the pair directly.
//   4. Neutral green ["#7a9865", "#3d5a32"].
//   5. Derive shadow from primary via -40 RGB darken clamp.
export function onbResolveSpotlightColors(name) {
  const neutral = ["#7a9865", "#3d5a32"];
  const q = String(name || "").trim().toLowerCase();
  if (!q) return neutral;

  const darken = (h) => {
    const v = String(h).replace("#", "");
    if (v.length !== 6) return h;
    const r = Math.max(0, parseInt(v.slice(0, 2), 16) - 40);
    const g = Math.max(0, parseInt(v.slice(2, 4), 16) - 40);
    const b = Math.max(0, parseInt(v.slice(4, 6), 16) - 40);
    return "#" + [r, g, b].map((n) => n.toString(16).padStart(2, "0")).join("");
  };

  // 1. STATIC_PLANT_COLOURS primary lookup — nested { month: { hex } } shape.
  const entry = (STATIC_PLANT_COLOURS && STATIC_PLANT_COLOURS[q]) || null;
  if (entry) {
    for (let m = 1; m <= 12; m++) {
      const monthEntry = entry[m] || entry[String(m)];
      const hex = monthEntry && monthEntry.hex;
      if (hex && typeof hex === "string" && hex.length >= 4) {
        return [hex, darken(hex)];
      }
    }
  }

  // 2. ONB_SPOTLIGHT_FALLBACKS keyword scan (hue words inside the plant name).
  for (const key of Object.keys(ONB_SPOTLIGHT_FALLBACKS)) {
    if (q.includes(key)) return ONB_SPOTLIGHT_FALLBACKS[key];
  }

  // 3. Neutral green.
  return neutral;
}
